const getters = {
  alert: (state) => {
    return state.alert
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/Alert/getters.js